import baseRoute from '../baseRoute';

export default `${baseRoute}/timezone` as const;
